import React, { useContext, useState } from 'react';
import { AuthContext } from '../../Context/UseContext';
import { HiBadgeCheck } from "react-icons/hi";
import { useDbUser } from '../../hooks/useUser';
import useScrollToTop from '../../hooks/useScrollToTop';
import useTitle from '../../hooks/useTitle';
import SmallSpinner from '../../Component/Spinner/SmallSpinner';
import toast from "react-hot-toast";
import { Link } from 'react-router-dom';
import Spinner from '../../Component/Spinner/Spinner';

const Dashboard = () => {
    const { user, loading } = useContext(AuthContext);
    const [dbUser, isDbUserLoading] = useDbUser(user?.email);
    const [VerifyLoading, setVerifyLoading] = useState(false);
    useScrollToTop();
    useTitle("Dashboard");

    if (loading || isDbUserLoading) return <Spinner />;

    const handleVerificationRequest = (id) => {
        setVerifyLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}/users/verification-request/${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify({
                email: dbUser.email,
                image: dbUser.image,
                name: dbUser.name,
                phone: dbUser.phone || null,
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    toast.success(data.message);
                } else {
                    toast.error(data.error);
                }
                setVerifyLoading(false);
            })
            .catch((err) => {
                toast.error(err.message);
                setVerifyLoading(false);
            });
    };


    return (
        <div className='h-screen text-gray-700 dark:text-white flex flex-col justify-center items-center pb-16'>
            <div className='flex flex-wrap justify-center items-center py-10'>
                <p className='text-6xl font-bold'>Welc</p>
                <div className='w-9 h-9 border-8 border-dashed rounded-full animate-spin mt-3 border-blue-400'></div>
                <p className='text-6xl font-bold mr-2'>me</p>
                <p className='text-6xl font-bold'>T</p>
                <div className='w-9 h-9 border-8 border-dashed rounded-full animate-spin mt-3 border-blue-400 mr-2'></div>
                <p className="text-6xl font-bold">DashBoard</p>
            </div>
            <div className='flex justify-center text-gray-500 items-center mt-4'>
                {/* <p className='text-3xl font-medium'>User Dashboard</p> */}
            </div>
            <div className="max-w-md p-8 sm:flex sm:space-x-6 dark:bg-gray-900 dark:text-gray-100">
                <div className="flex-shrink-0 w-full mb-6 h-44 sm:h-32 sm:w-32 sm:mb-0">
                    <img src={dbUser?.image} alt={dbUser?.name} className="object-cover object-center w-full h-full rounded dark:bg-gray-500" />
                </div>
                <div className="flex flex-col space-y-4">
                    <div className='flex'>
                        <h2 className="text-2xl font-semibold">{dbUser?.name}</h2>
                        {dbUser?.isVerified && (
                            <HiBadgeCheck className="text-green-500 text-2xl" />
                        )}
                    </div>
                    <div className="space-y-1">
                        <span className="flex items-center space-x-2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-label="Email address" className="w-4 h-4">
                                <path fill="currentColor" d="M274.6,25.623a32.006,32.006,0,0,0-37.2,0L16,183.766V496H496V183.766ZM464,402.693,339.97,322.96,464,226.492ZM256,51.662,454.429,193.4,311.434,304.615,256,268.979l-55.434,35.636L57.571,193.4ZM48,226.492,172.03,322.96,48,402.693ZM464,464H48V440.735L256,307.021,464,440.735Z"></path>
                            </svg>
                            <span className="dark:text-gray-400">{dbUser?.email}</span>
                           
                        </span>
                        {dbUser.role === "seller" && !dbUser.isVerified && (
                            <button
                                // size="xs"
                                className="btn btn-primary"
                                color="warning"
                                disabled={VerifyLoading}
                            onClick={() => handleVerificationRequest(dbUser?._id)}
                            >
                                {VerifyLoading ? (
                                    <SmallSpinner />
                                ) : (
                                    <HiBadgeCheck className="mr-1" />
                                )}
                                {VerifyLoading ? "Verifying..." : "Verify Your Account"}
                            </button>
                        )}
                    </div>
                    
                <div className="mt-4 flex space-x-3 lg:mt-6">
                    <Link
                        to="/dashboard/profile"
                            className="btn btn-sm btn-primary"
                    >
                        My Profile
                    </Link>
                    <Link
                        to="/dashboard/update-profile"
                            className="btn btn-sm btn-ghost"
                    >
                        Update Profile
                    </Link>
                </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;